module.exports = __webpack_public_path__ + "img/af.66d30d60.svg";